module.exports = __webpack_public_path__ + "img/launching-soon.34bb31a7.png";